/* eslint react/no-did-mount-set-state: 0 */
/* eslint react/prop-types: 0 */
/* eslint consistent-return: 0 */
/* global $ */
import React from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './ModalError.css';
import { urlPrefix } from '../../../clientConfig';

class ModalError extends React.Component {
  componentDidMount() {
    $('#ModalError').modal({ backdrop: 'static', keyboard: false });
    $('.close').hide();
  }

  render() {
    const { hideLayout } = this.props;
    let url = `${urlPrefix}/telemedicina/solicitud-turnos`;

    // Para el iframe que se implementa en el dashboard de la web
    if (hideLayout) {
      url += '?hideLayout=true';
    }

    return (
      <div className="modal fade" id="ModalError">
        <div className="modal-dialog">
          <div className={`${s.modalContent} modal-content`}>
            <div className="modal-header">
              <h5 className="modal-title">Error</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className={`${s.modalBody} modal-body`}>
              <div>
                {this.props.msg}
              </div>
            </div>
            <div className={`${s.modalFooter} modal-footer`}>
              <a
                type="button"
                className={`btn btn-default`}
                style={{
                  width: '140px',
                  color: '#fff',
                  fontSize: '14px',
                  backgroundColor: '#e4002b',
                  cursor: 'pointer',
                  borderRadius: '.25rem',
                  fontFamily: 'Roboto, Medium, sans-serif',
                  fontWeight: 'bold',
                }}
                href={url}
              >
                Aceptar
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  hideLayout: state.auth.hideLayout,
});

export default connect(mapStateToProps, null)(withStyles(s)(ModalError));



// WEBPACK FOOTER //
// ./src/components/Telemedicina/ModalError/ModalError.js